// Features.jsx
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCoverflow, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import "./Features.css";

// Icons
import {
  MdInsights,
  MdSecurity,
  MdPriceChange,
  MdEventAvailable,
} from "react-icons/md";
import { FaLayerGroup } from "react-icons/fa";

// ✅ simple hook to detect mobile
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
}

function Features() {
  const isMobile = useIsMobile(768);

  const features = [
    {
      icon: <FaLayerGroup />,
      title: "Multi-Platform Integration",
      description:
        "Centralize calls from different apps and channels into one seamless app for easier management.",
    },
    {
      icon: <MdInsights />,
      title: "Advanced Analytics",
      description:
        "Track your call performance and earnings with real-time analytics and clear insights.",
    },
    {
      icon: <MdPriceChange />,
      title: "Customizable Pricing",
      description:
        "Set your own rates per minute, stay in control, and maximize your earning potential.",
    },
    {
      icon: <MdEventAvailable />,
      title: "Call Scheduling",
      description:
        "Schedule calls for a desired time so both parties can plan ahead and avoid missed connections.",
    },
    {
      icon: <MdSecurity />,
      title: "KYC Verified & Trusted",
      description:
        "KYC helps keep the platform safe, trusted, and secure for both callers and recipients.",
    },
  ];

  return (
    <section className="features" id="features">
      <div className="features__header">
        <h2>
          Why Use <span className="highlight">OKIRI</span>?
        </h2>
        <p>
          Features That Put You In Control. Empowering you to connect, earn, and
          <br /> manage calls like never before.
        </p>
      </div>

      {/* ✅ MOBILE: simple list (no movement) */}
      {isMobile ? (
        <div className="features__list">
          {features.map((feature, index) => (
            <div key={index} className="features__card">
              <div className="features__iconWrap" aria-hidden="true">
                <span className="features__icon">{feature.icon}</span>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      ) : (
        /* ✅ DESKTOP/TABLET: swiper with coverflow */
        <Swiper
          modules={[Navigation, EffectCoverflow, Autoplay]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView="auto"
          spaceBetween={-10}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          speed={900}
          coverflowEffect={{
            rotate: 45,
            stretch: 0,
            depth: 120,
            modifier: 1,
            slideShadows: true,
          }}
          navigation
          className="features__slider"
        >
          {features.map((feature, index) => (
            <SwiperSlide key={index} className="features__card">
              <div className="features__iconWrap" aria-hidden="true">
                <span className="features__icon">{feature.icon}</span>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </section>
  );
}

export default Features;
